import {
    defineStore,
} from 'pinia'

export const useLoadingStore = defineStore('loading', () => {
    const inFlight = ref(0)

    const active = computed((): boolean => inFlight.value > 0)

    function begin(): void {
        inFlight.value++
    }

    function end(): void {
        inFlight.value--
    }

    return {
        active,
        begin,
        end,
    }
})
